import {
  type WeightUnit,
  weightFromKg,
} from "@/lib/weight-training/measurement-contract";

export type NativeStrengthTarget = {
  preferredWeightUnit?: WeightUnit;
  currentSetWeightKg: number;
  currentSetReps: number;
  currentSetNumber: number;
  currentSetDurationSeconds: number;
  currentSetDistanceMeters: number;
  currentSetTrackMode: "reps" | "time" | "distance";
};

const number = (value: number) => Math.round(value * 100) / 100;
export function formatNativeStrengthTarget(info: NativeStrengthTarget) {
  const unit = info.preferredWeightUnit ?? "kg";
  const weight =
    info.currentSetWeightKg > 0
      ? `${number(weightFromKg(info.currentSetWeightKg, unit) ?? 0)} ${unit}`
      : null;
  const target =
    info.currentSetTrackMode === "time"
      ? info.currentSetDurationSeconds > 0
        ? `${number(info.currentSetDurationSeconds)} s`
        : null
      : info.currentSetTrackMode === "distance"
        ? info.currentSetDistanceMeters > 0
          ? `${number(info.currentSetDistanceMeters)} m`
          : null
        : info.currentSetReps > 0
          ? `${info.currentSetReps} reps`
          : null;
  if (weight && target)
    return info.currentSetTrackMode === "reps"
      ? `${weight} × ${info.currentSetReps}`
      : `${weight} · ${target}`;
  return (
    weight ??
    target ??
    (info.currentSetNumber > 0 ? `Set ${info.currentSetNumber}` : "—")
  );
}
